import { useDispatch, useSelector } from 'react-redux'
import { a11ySelector, setFontSize } from '../../../../redux/slices/a11y'
import TextSwitcher from '../../../reusable/Accessibility/TextSwitcher'

const FontSizeSwitcher = () => {
  const { fontSize } = useSelector(a11ySelector)
  const btnMinusDisabled = fontSize <= 16
  const btnPlusDisabled = fontSize >= 20
  const dispatch = useDispatch()

  const handleMinus = () => {
    dispatch(setFontSize(fontSize - 1))
  }
  const handlePlus = () => {
    dispatch(setFontSize(fontSize + 1))
  }

  return (
    <TextSwitcher
      title="Розмір тексту"
      value="Аа"
      handleMinus={handleMinus}
      handlePlus={handlePlus}
      btnMinusDisabled={btnMinusDisabled}
      btnPlusDisabled={btnPlusDisabled}
    />
  )
}

export default FontSizeSwitcher
